import { Tooltip as TooltipUI, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

export function Tooltip({ children, content, mode = 'light' }: { children: React.ReactNode | string; content: string | React.ReactNode; mode?: 'light' | 'dark' }) {
  return (
    <TooltipProvider>
      <TooltipUI>
        <TooltipTrigger>{children}</TooltipTrigger>
        <TooltipContent className={cn(mode == 'dark' && 'bg-grey-900 text-white')}>{content}</TooltipContent>
      </TooltipUI>
    </TooltipProvider>
  )
}
